import {Component} from '@angular/core';
import {NgProgress, NgProgressRef} from '@ngx-progressbar/core';
import { MatDialog } from '@angular/material/dialog';
import { InformationComponent } from './pages/dialogs/information/information.component';

@Component({
    selector: 'je-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    progressRef: NgProgressRef;

    constructor(
        private ngProgress: NgProgress,
        public dialog: MatDialog
        ) {
        this.progressRef = this.ngProgress.ref();
    }
    
  openInfoDialog() {
    this.dialog.open(InformationComponent);
  }
}